<div class="gmt-input">
  <label class="gmt-input__label" *ngIf="label" [ngClass]="{'required': required}">{{ label }}</label>
  <div class="gmt-input__input-wrapper" [ngClass]="{'readonly': readonly}">
    <ng-content></ng-content>
  </div>
</div>
